import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { HeaderComponent } from './components/header/header.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { Html5VideoPlayerModule } from '@teamfoster/sdk/html5-video-player';
import { IconModule } from '@teamfoster/sdk/icon';
import { GridOverlayComponent } from './components/grid-overlay/grid-overlay.component';
import { IconComponent } from './components/icon/icon.component';
import { ImageComponent } from './components/image/image.component';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { SeoModule } from '../seo/seo.module';
import { LangSwitcherComponent } from './components/lang-switcher/lang-switcher.component';
import { ResizePipe } from '@teamfoster/sdk/image';

const moduleExports = [
  LoaderIndicatorComponent,
  HeaderComponent,
  TopbarComponent,
  FooterComponent,
  GridOverlayComponent,
  IconComponent,
  ImageComponent,
  LangSwitcherComponent,
];

@NgModule({
  imports: [CommonModule, RouterModule, InViewModule, TextUtilityModule, Html5VideoPlayerModule, IconModule, DictionaryNgrxModule, SeoModule, ResizePipe],
  declarations: [...moduleExports],
  exports: [...moduleExports],
})
export class CoreModule {}
